// Weather in the UI language. The backend asks OpenWeatherMap for
// descriptions in `lang` and caches per language; storm messages come
// back with a `messageKey` translated here (falls back to the English
// `message` for an older backend).
export function weatherLang(i18n) {
  return (i18n?.resolvedLanguage || i18n?.language || "en").startsWith("es") ? "es" : "en";
}

export function riskMessage(t, risk) {
  if (!risk) return "";
  if (!risk.messageKey) return risk.message || "";
  return t(`weather.risk.${risk.messageKey}`, { speed: risk.speed, defaultValue: risk.message });
}
